/**
 * The colours a status wears, declared once.
 *
 * Three screens each carried their own copy of this map and they had begun to differ
 * by a shade. A Completed training should look the same in the register, on the
 * detail page and in the panel that opens from a row, or the eye stops trusting it.
 */
export const STATUS_CLASS = {
  Draft: "bg-slate-500/10 text-slate-700 dark:text-slate-300",
  Scheduled: "bg-indigo-500/10 text-indigo-700 dark:text-indigo-400",
  Completed: "bg-emerald-500/10 text-emerald-700 dark:text-emerald-400",
  Cancelled: "bg-zinc-500/10 text-zinc-700 dark:text-zinc-400",
};

export const statusClass = (s) => STATUS_CLASS[s] || "bg-muted text-foreground";

export const ATTENDANCE_TEXT_CLASS = {
  Present: "text-emerald-700 dark:text-emerald-400",
  Late: "text-amber-700 dark:text-amber-400",
  Absent: "text-destructive-text",
  "Not Marked": "text-muted-foreground",
};
